// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__pVOdg","employee-header-item":"Header_employee-header-item__r4uuN"};